import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { report_bulk_download_loading : true, report_bulk_download: null, report_bulk_download_error: false};

export function reportBulkDownloadReducer(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_REPORT_BULK_DOWNLOAD_API:
        return {
            report_bulk_download_loading: true,
            report_bulk_download: null,
            report_bulk_download_error: false
        };
      case organisationConstants.RECIEVE_REPORT_BULK_DOWNLOAD_API:
        return {
            report_bulk_download_loading: false,
            report_bulk_download: action.bulkDownload,
            report_bulk_download_error: false
        };
      case organisationConstants.ERROR_REPORT_BULK_DOWNLOAD_API:
        return { 
            report_bulk_download_loading: false,
            report_bulk_download: null,
            report_bulk_download_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/bulkDownload/downloadBulkReport.js